import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
              <i className="ri-time-line text-secondary-500 mr-2"></i>
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新更新的漫画章节，追更不等待</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-3 bg-background-50 rounded-xl p-3 hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-16 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-foreground-950 truncate">{comic.title}</h4>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {comic.chapters[comic.chapters.length - 1]?.title || '最新话'}
                </p>
                <p className="text-xs text-foreground-400 mt-1">{comic.updatedAt}</p>
              </div>
              <div className="flex-shrink-0">
                <span className="inline-block px-2 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
                  {comic.status}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}